import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { ControlType, SimpleInputModule } from '@hglobal/common';
import { ShopOrder, FormType, UkrposhtaOrderForm } from '@pt/models';

@Component({
  selector: 'pt-delivery-ukrposhta',
  templateUrl: './ukrposhta.component.html',
  styleUrls: ['./ukrposhta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    SimpleInputModule,
  ],
})
export class UkrposhtaComponent implements OnInit {
  readonly #formBuilder = inject(FormBuilder);

  order = input.required<ShopOrder>();
  form = input.required<FormType<UkrposhtaOrderForm, 'delivery'>>();

  readonly controlTypes = ControlType;

  ngOnInit(): void {
    this.form().removeControl('delivery');
    this.form().addControl(
      'delivery',
      this.#formBuilder.group({
        country: [this.order().location.country, Validators.required],
        postcode: [<any>null, Validators.required],
        regionState: ['', Validators.required],
        city: ['', Validators.required],
        address: ['', Validators.required],
        apartment: '',
      }),
    );
  }
}
